export default "__VITE_ASSET__BM10Cy6M__"